import { render, staticRenderFns } from "./Politica_confidentialitate.vue?vue&type=template&id=41d70578&"
import script from "./Politica_confidentialitate.vue?vue&type=script&lang=js&"
export * from "./Politica_confidentialitate.vue?vue&type=script&lang=js&"
import style0 from "./Politica_confidentialitate.vue?vue&type=style&index=0&id=41d70578&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports